import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { EmtTheme } from "../types";

export type EmtChatMessagesWrapperProps = BoxProps & { nonce?: string };

const ChatMessagesWrapper = styled(Box)(({ theme }: { theme?: EmtTheme }) => ({
  display: "flex",
  flexDirection: "column-reverse",
  rowGap: "16px",
  width: "100%",
  height: "100%",
  overflowY: "scroll",
  paddingRight: "16px",
  "&::-webkit-scrollbar": {
    width: "5px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme?.palette.greyGradient[150],
    borderRadius: "8px",
  },
  scrollbarColor: `${theme?.palette.greyGradient[150]} transparent`,
}));

export function EmtChatMessagesWrapper(props: EmtChatMessagesWrapperProps) {
  const { ...rest } = props;
  return <ChatMessagesWrapper {...rest} />;
}
